import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { AgitationSection, WhoIsItFor, FAQSection, FinalCTA, Footer, PriceAnchorSection } from './shared_components';
import { SocialProofSection } from './components/SocialProofSection';
import { OfferSection } from './components/OfferSection';
import { IndividualProducts } from './components/IndividualProducts';
import { GuaranteeSection } from './components/GuaranteeSection';
import { WhatsAppButton } from './WhatsAppButton';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48566694772993:1';
export function App() {
  const [showFloat, setShowFloat] = useState(false);
  useEffect(() => {
    const fn = () => setShowFloat(window.scrollY > 700);
    window.addEventListener('scroll', fn, {
      passive: true
    });
    return () => window.removeEventListener('scroll', fn);
  }, []);
  return <div className="w-full min-h-screen bg-navy-mid font-sans overflow-x-hidden" data-id="element-0">
      <StickyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <AgitationSection data-id="element-4" />
      <SocialProofSection data-id="element-5" />
      <OfferSection data-id="element-6" />
      <PriceAnchorSection data-id="element-7" />
      <IndividualProducts data-id="element-8" />
      <WhoIsItFor data-id="element-9" />

      <FAQSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />

      {/* ── WHATSAPP FLOTANTE ── Siempre visible, sobre todo lo demás */}
      <WhatsAppButton data-id="element-13" />

      {/* ── MOBILE CTA BAR ── Solo en mobile, debajo del WhatsApp */}
      <AnimatePresence data-id="element-14">
        {showFloat && <motion.div initial={{
        y: 90,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 90,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed bottom-0 left-0 right-0 z-40 p-3 bg-navy-dark/95 backdrop-blur-md border-t border-gold/20 md:hidden" style={{
        paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
      }} data-id="element-15">
            <a href={KIT_URL} className="btn-gold block font-display font-bold text-base py-4 rounded-xl text-center no-underline" data-id="element-16">
              Kit Completo — $62.900 →
            </a>
          </motion.div>}
      </AnimatePresence>
    </div>;
}